import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { IconButton } from '@material-ui/core';
import { ArrowBack, CloseSharp } from '@material-ui/icons';
import { CarouselContext, CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import goodStand from '../../assets/newSvg/good-stand1.png';

const Styles = styled.div`
    font-family: var(--font-fa);
	letter-spacing: -0.75px !important;
    min-height: 90vh;
    position: relative;
    display: flex;
    flex-direction: column;
    .modal-title {
        z-index: 50;
        position: sticky;
        top: 0;
        background-color: #fff;
        padding: 0.1rem 1rem 0.2rem 0.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid lightgray;
    }
    
    .content {
        flex-grow: 1;
        margin: 0.5rem 1rem;
        display: flex;
        gap: 0.7rem;
        .slideHorizontal___1NzNV,
        .horizontalSlider___281Ls {
            transform: scale(1) !important;
        }
        .carousel {
            width: 55%;
            flex-grow: 1;
            * {
                overflow: visible;
                ul {
                    padding: 0;
                }
            }
            overflow: hidden;
            margin: 0 auto;
            background-color: var(--gray-0);
            display: flex;
            flex-direction: column;
            position: relative;
            .sh-g-image {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: block;
            }
            .backstand{
                position: absolute;
                inset: 0;
                box-shadow: var(--shadow-15);
                aspect-ratio: 1;
                border-radius: var(--border-radius-9);
                width: 100%;
            }
            .g-image{
                /* position: relative;
                margin: auto 28%  ;
                padding-top: 36%;
                width: 44%; */
                position: relative;
                display: block;
                aspect-ratio: 1;
                border-radius: var(--border-radius-9);
                color: var(--text-3);
                overflow: hidden;
                .shadow {
                    position: absolute;
                    width: 52.4%;
                    height: 10%;
                    display: block;
                    left: calc(50% - calc(55% / 2));
                    padding-top: calc(26.5% + 42%);
                    margin: auto;
                    object-fit: fill;
                    transition: all 0.3s ease-in-out;
                    transform-origin: bottom;
                    opacity: 0.2;
                    filter: brightness(0.2) blur(8px);
                    transform-origin: bottom;
                    transform: skewX(60deg);
                    clip-path: ellipse(45% 4.7% at bottom);
                }
                .reflection{
                    position: absolute;
                    width: 52.4%;
                    height: 20%;
                    display: block;
                    left: calc(50% - calc(52% / 2));
                    padding-top: calc(26.5% + 32%);
                    margin: auto;
                    object-fit: fill;
                    transition: all 0.3s ease-in-out;
                    transform-origin: bottom;
                    opacity: 0.4;
                    filter: brightness(1.8) blur(2px);
                    transform-origin: bottom;
                    transform: scale(1, -1);
                    clip-path: ellipse(59% 8.1% at bottom);
                }
                .main{
                    position: relative;
                    width: 52.4% ;
                    display: block;
                    padding-top: 28%;
                    margin: auto;
                    object-fit: contain;
                    transition: all 0.3s ease-in-out;
                    transform-origin: bottom;
                }
            }
        }
        .items {
            flex-grow: 0.7;
            width: 45%;
            display: flex;
            flex-direction: column;
            .shop-title-images {
                padding: 1rem 0 0.3rem;
                font-weight: 500;
                font-size: 16px;
            }
            .items-container {
                display: flex;
                flex-wrap: wrap;
                gap: 0.5rem;
                .item {
                    width: 50px;
                    border: 1px solid var(--gray-16);
                    border-radius: 4px;
                    aspect-ratio: 1;
                    &.active {
                        box-shadow: 0 0 0 2px #1811b730;
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                        object-fit: cover;
                    }
                }
            }
        }
        .devider-image {
            width: 1px;
            background-color: var(--gray-16);
        }
    }
    @media screen and (max-width :850px) {
        .content {
            flex-direction: column;
            .carousel {
                width: 100%;
                flex-grow: 0;
            }
            .items {
                flex-grow: 0.7;
                width: 100%;
            }
        }
    }
`


export default function GoodPicManager({title, selectedImg, setSelectedImg, open, setOpen, good, shops}) {
  const carouselRef = useRef();
  useEffect(() => {
    if(carouselRef.current){
        carouselRef.current.carouselStore.setStoreState({currentSlide: selectedImg})
    }
  }, [selectedImg]);
  useEffect(() => {
    if(carouselRef.current){
        function onChange() {
            setSelectedImg(carouselRef.current.carouselStore.state.currentSlide);
        }
        carouselRef.current.carouselStore.subscribe(onChange);
        return () => carouselRef.current.carouselStore.unsubscribe(onChange);
    }
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const makeImagesList = () => {
    let images = [good.G_IMAGE];
    for (let i = 0; i < shops.length; i++) {
        const shop = shops[i];
        for (let j = 0; j < shop.goods.length; j++) {
            const goodshop = shop.goods[j];
            images.push(...goodshop.SHOP_GOODS_IMAGE)
        }
    }
    return images
  }
  const makeImageSlides = (images = []) => {
    return images.map((v, i) => {
      if(i === 0){
        return (
          <Slide
            key={i} 
            index={images.length - (i+1)} 
            classNameVisible="slider-good-visible"
          >
            <img src={goodStand} alt='goodStand' className="backstand"/>
            <div className="g-image header-image-enter-done">
                <img className="shadow" src={v} alt={good.G_NAME}/>
                <img className="reflection" src={v} alt={good.G_NAME}/>
                <img className="main" src={v} alt={good.G_NAME}/>
            </div> 
          </Slide>
        )
      }
      return (
        <Slide
          key={i} 
          index={images.length - (i+1)} 
          classNameVisible="slider-good-visible"
        >
          <img className="sh-g-image" src={v.G_IMG_ADDRESS} alt={good.G_NAME}/>
        </Slide>
      )
    })
  }
  const makeItems = () => {
    let imagesHtml = [];
    let mainIndex = 1;
    for (let i = 0; i < shops.length; i++) {
        const shop = shops[i];
        
        let shopimages = [];
        for (let j = 0; j < shop.goods.length; j++) {
            const goodshop = shop.goods[j];
            for (let k = 0; k < goodshop.SHOP_GOODS_IMAGE.length; k++) {
                const imageObj = goodshop.SHOP_GOODS_IMAGE[k];
                shopimages.push(
                    <div 
                        data-index={mainIndex} 
                        className={'item' + ((selectedImg === mainIndex) ? " active" : "")} 
                        onClick={(e) => {
                            setSelectedImg(parseInt(e.target.dataset.index))
                        }}
                    >
                        <img data-index={mainIndex} src={imageObj.G_IMG_ADDRESS} alt='main image'/>
                    </div>
                )
                mainIndex+= 1;
            }
        }
        if(shopimages.length){
            imagesHtml.push(
                <div className='shop-title-images'>
                    تصاویر فروشگاه {shop.SH_NAME}
                </div>
            )
        }
        imagesHtml.push(
            <div className='items-container'>
                {shopimages}
            </div>
        )
    }
    return (
        <>
        <div className='items-container'>
            <div className={'item' + ((selectedImg === 0) ? " active" : "")} onClick={() => setSelectedImg(0)}>
                <img src={good.G_IMAGE} alt='main image'/>
            </div>
        </div>
        {imagesHtml}
        </>
    )
  }
  let images = makeImagesList();
  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        PaperProps={{
            style: {
                borderRadius: "16px"
            }
        }}
      >
        <Styles>
            <BootstrapDialogTitle id="customized-dialog-title" className={"modal-title"} onClose={handleClose}>
                تصاویر {title}
            </BootstrapDialogTitle>
            <div className='content'>
                <CarouselProvider
                    ref={carouselRef}
                    naturalSlideWidth={100}
                    naturalSlideHeight={(window.innerWidth < 850) ? 100 : 90}
                    totalSlides={images.length}
                    playDirection="backward"
                    currentSlide={0}
                    visibleSlides={1}
                    > 
                    <Slider>
                        {makeImageSlides(images)}
                    </Slider>
                </CarouselProvider>
                <div className='devider-image'></div>
                <div className='items'>
                    {makeItems()}
                </div>
            </div>
        </Styles>
      </Dialog>
    </React.Fragment>
  );
}



function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
  
    return (
      <div {...other}>
        <div>{children}</div>
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseSharp />
          </IconButton>
        ) : null}
      </div>
    );
}